import { Button } from '@telavita-core/react-design-kit'
import React from 'react'

import { Footer } from './styles'

interface IPatientFooterProps {
  isEmpty: boolean
  disabled: boolean
  onClickOnSeeMore: () => void
  onClickOnShowModal: () => void
}

export const PatientFooter = ({
  isEmpty,
  disabled,
  onClickOnSeeMore,
  onClickOnShowModal,
}: IPatientFooterProps): JSX.Element => {
  return (
    <Footer isEmpty={isEmpty}>
      <Button
        uppercase={false}
        disabled={disabled}
        variant='text'
        onClick={onClickOnSeeMore}
      >
        Ver mais
      </Button>

      <Button
        uppercase={false}
        variant='text'
        onClick={onClickOnShowModal}
      >
        O que fazer neste caso?
      </Button>
    </Footer>
  )
}